import React from 'react'
import { RetentionRule, TTLRetentionRule, TTLRetentionRuleConfig } from '../../../models/RetentionPolicy'

export const RetentionPolicyTTLRuleBody: React.FC<{ retentionRule: RetentionRule }> = ({ retentionRule }) => {
  const rule = retentionRule as TTLRetentionRule
  return (
    <>
      <div>
        <div>Rule</div>
        <div aria-label='Rule'>
          <RetentionPolicyTTLConfigView ttlConfig={rule.config} />
        </div>
      </div>
    </>
  )
}

export const RetentionPolicyTTLConfigView: React.FC<{ ttlConfig: TTLRetentionRuleConfig }> = ({ ttlConfig }) => {
  if (ttlConfig.unit === 'hour') {
    const days = Math.floor(ttlConfig.value / 24)
    const hours = ttlConfig.value % 24
    return (
      <div>
        {days > 0 ? (
          <>
            {days} day{days > 1 ? 's' : ''}{' '}
          </>
        ) : null}
        {hours > 0 ? (
          <>
            {hours} hour{hours > 1 ? 's' : ''}{' '}
          </>
        ) : null}
      </div>
    )
  }
  return (
    <div>
      {ttlConfig.value} {ttlConfig.unit}
      {ttlConfig.value > 1 ? 's' : ''}
    </div>
  )
}
